// extracted by mini-css-extract-plugin
export default {"tableWrap":"TableList_tableWrap__-pRBi","item":"TableList_item__2-DKv","maxH130":"TableList_maxH130__ntaL2","flexCenter":"TableList_flexCenter__aeZkz"};